import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VisitRoleAdminComponent } from './component/visit-role-admin/visit-role-admin.component';

import { CommonLayoutModule, CommonUIModule, DictionaryFieldsModule, MasterDetailModule } from '@sdbn/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DictionaryModule } from '@sdbn/common';
import { CommonTranslationModule } from '@sdbn/common';
import { VisitRoleTaskDialogComponent } from './component/visit-role-task-dialog/visit-role-task-dialog.component';
import { DragDropModule } from '@angular/cdk/drag-drop';



@NgModule({
  declarations: [
    VisitRoleAdminComponent,
    VisitRoleTaskDialogComponent
  ],
  imports: [
    CommonModule,
    CommonLayoutModule,
    FormsModule,
    ReactiveFormsModule,

    DictionaryModule,
    CommonTranslationModule,
    CommonUIModule,
    CommonUIModule,
    MasterDetailModule,
    DictionaryFieldsModule,
    DragDropModule
  ],
  exports: [
    VisitRoleAdminComponent
  ]
})
export class VisitRolesModule { }
